"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRetry = void 0;
const tslib_1 = require("tslib");
const sleep_1 = require("./sleep");
class IkeRetry {
    /**
     * Retry a function `count` times until it returns true
     *
     * @param fn Function to try to execute
     * @param count max number of times to try
     * @param minDelay Delay between attempts (i * delay)
     */
    static retry(fn_1, log_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function* (fn, log, count = 3, minDelay = 50) {
            for (let i = 1; i <= count; i++) {
                const exists = yield fn();
                if (exists) {
                    return true;
                }
                const delay = minDelay * i;
                log.info({ attempt: i, maxAttempt: count, delay }, 'RetrySleep');
                yield sleep_1.IkeSleep.sleep(delay); // 25, 50, 75, 100ms delay
            }
            return false;
        });
    }
    /**
     * Retry a function until it stops throwing a error
     *
     * @param fn Function to try to execute
     * @param count max number of times to try
     * @param minDelay Delay between attempts (i * delay)
     */
    static retryThrowable(fn_1, log_1) {
        return tslib_1.__awaiter(this, arguments, void 0, function* (fn, log, count = 3, minDelay = 50) {
            let obj = null;
            const errors = [];
            yield IkeRetry.retry(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    obj = yield fn();
                }
                catch (e) {
                    log.warn({ error: e }, 'RetryThrowable');
                    errors.push(e);
                    return false;
                }
                return true;
            }), log, count, minDelay);
            if (obj == null && errors.length > 0) {
                throw errors.pop();
            }
            return obj;
        });
    }
}
exports.IkeRetry = IkeRetry;
//# sourceMappingURL=retry.js.map